<template>
  <popper ref="logger" trigger="click">
    <div class="popper">
      <table style="table-layout: fixed; width: 100%">
        <template v-if="intentAnalysed">
          <template v-for="info in intentInfo['intentAnalysed']">
            <logger-details
              :key="info.labelName"
              :value="reformatedIntentAnalysed[info.propertyName]"
              :label-name="info.labelName"></logger-details>
          </template>
        </template>
        <template v-if="actionDeduced">
          <template v-for="info in intentInfo['actionDeduced']">
            <logger-details
              :key="info.labelName"
              :value="actionDeduced[info.propertyName]"
              :label-name="info.labelName"></logger-details>
          </template>
        </template>
        <template v-if="context">
          <template v-for="info in intentInfo['context']">
            <logger-details
              :key="info.labelName"
              :value="context[info.propertyName]"
              :label-name="info.labelName"></logger-details>
          </template>
        </template>
      </table>
    </div>

    <div slot="reference" class="toolTip">
      <i class="fa fa-info-circle"></i>
    </div>
  </popper>
</template>

<script>
import Popper from 'vue-popperjs/dist/js/vue-popper.min.js'
import LoggerDetails from './LoggerDetails.vue'

import '@/assets/styles/popper.css'

export default {
  name: 'Logger',
  components: {
    popper: Popper,
    loggerDetails: LoggerDetails
  },
  props: {
    intentAnalysed: { type: Object, default: null },
    context: { type: Object, default: null },
    actionDeduced: { type: Object, default: null },
    intentInfo: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isHovered: { type: Boolean }
  },
  computed: {
    reformatedIntentAnalysed: function () {
      const { intentName, intentDetectionConfidence, parameters } = this.intentAnalysed

      return {
        intentName,
        intentDetectionConfidence: this.roundConfidence(intentDetectionConfidence),
        parameters: this.cleanNLPEntities(parameters)
      }
    }
  },
  watch: {
    isHovered: function () {
      if (!this.isHovered) {
        this.$refs.logger.showPopper = false
      }
    }
  },
  methods: {
    cleanNLPEntities: function (parameters) {
      const cleanedParameters = []
      const entities = Object.entries(parameters || {})

      for (const [entityName, entityDetail] of entities) {
        cleanedParameters.push(`${entityName} : "${entityDetail.stringValue}"`)
      }

      return entities.length ? cleanedParameters.join(', ') : null
    },
    roundConfidence: function (confidence) {
      return confidence ? Math.round(confidence * 100) / 100 : null
    }
  }
}
</script>
